// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2YFeT","errors":"Errors_errors__3Pkbl"};